import { Component, ElementRef, OnInit } from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'apps/driver-dashboardfe/src/app/core/services/authentication/authentication.service';
import { DialogHandlerService } from 'apps/driver-dashboardfe/src/app/core/services/dialog-handler/dialog-handler.service';
import { JoinService } from 'apps/driver-dashboardfe/src/app/core/services/join/join.service';
import { MatchValidator } from 'apps/driver-dashboardfe/src/app/shared/validators/mustMatch.validator';
import { pattern } from 'apps/driver-dashboardfe/src/app/shared/constants/pattern.constant';

@Component({
    standalone: false,
    selector: 'octo-setup-password',
    templateUrl: './setup-password.component.html',
    styleUrls: ['./setup-password.component.scss'],
})
export class SetupPasswordComponent implements OnInit {
    email: string = '';
    setupPasswordForm = new UntypedFormGroup({});
    setupFormSubmitted: boolean = false;
    userId: any = '';

    constructor(
        private activeRoute: ActivatedRoute,
        private elementRef: ElementRef,
        private fb: UntypedFormBuilder,
        private dialogService: DialogHandlerService,
        private joinService: JoinService,
        private authService: AuthenticationService,
        private router: Router
    ) {
        activeRoute.queryParams.subscribe((params) => {
            this.email = params['email'];
        });
    }

    ngOnInit(): void {
        this.joinService
            .login({ email: this.email, password: '0ct0pu$1nt3ract1v3' })
            .subscribe((data) => {
                this.authService.setToken(data.data.token);
                localStorage.setItem('status', data.data.driver_status);
            });
        this.joinService.getJoinDetails().subscribe((data) => {
            this.userId = data.data.id;
        });
        this.initSetupPasswordForm();
    }

    initSetupPasswordForm(): void {
        this.setupPasswordForm = this.fb.group(
            {
                email: this.email,
                password: [
                    '',
                    [
                        Validators.required,
                        Validators.minLength(8),
                        Validators.maxLength(50),
                        Validators.pattern(pattern.password),
                    ],
                ],
                confirm_password: [
                    '',
                    [
                        Validators.required,
                        Validators.minLength(8),
                        Validators.maxLength(50),
                        Validators.pattern(pattern.password),
                    ],
                ],
                agree: [null, Validators.required],
            },
            {
                validators: MatchValidator('password', 'confirm_password'),
            }
        );
    }

    get setupForm() {
        return this.setupPasswordForm.controls;
    }

    onSetupSubmit(): void {
        this.setupFormSubmitted = true;
        if (!this.setupPasswordForm.valid) {
            return;
        }
        let temp = JSON.parse(localStorage.getItem('user') || '{}');
        temp['password'] = this.setupForm['password'].value;
        this.joinService.signup(temp).subscribe((data) => {
            this.router.navigate(['login/two_factor_code']);
        });
        // this.joinService.editJoinDetails(this.userId, {password:this.setupForm['password'].value} ).subscribe((data) => {
        //     this.router.navigate(['login/two_factor_code']);
        // })
    }

    showTermsModal(type: any): void {
        this.dialogService.showTermsModal(type).subscribe({});
    }
}
